import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { useDescargarDocumentacionAdicionalZipMutation } from '../../../services/visitasApi';

// ZIP con la "Documentación adicional" de la visita (SMP-551). Recibe la visita al descargar porque en la
// grilla cambia segun la fila; quien lo usa decide si mostrar la accion (puedeDescargarInformacionAdicional).
export const useDescargaInformacionAdicional = () => {
    const { t } = useTranslation('visitas');
    const [descargarZip] = useDescargarDocumentacionAdicionalZipMutation();
    const [descargandoInformacionAdicional, setDescargandoInformacionAdicional] = useState(false);

    const descargarInformacionAdicional = async (visita: any) => {
        if (descargandoInformacionAdicional || !visita?.id) return;

        setDescargandoInformacionAdicional(true);
        try {
            const respuesta = await descargarZip({ idVisita: visita.id }).unwrap();
            const presignedUrl = respuesta?.data?.presignedUrl;

            if (!presignedUrl) throw new Error('Respuesta sin presignedUrl');

            // Un enlace en la misma pestaña: window.open despues de un await lo frena el bloqueador de
            // popups, y S3 sirve el ZIP como descarga, sin salir de la grilla.
            const enlace = document.createElement('a');
            enlace.href = presignedUrl;
            document.body.appendChild(enlace);
            enlace.click();
            enlace.remove();

            enqueueSnackbar(t('alerts.downloadInformacionAdicional.success'), {
                variant: 'success'
            });
        } catch (error: any) {
            const mensajeBackend = error?.data?.message;
            enqueueSnackbar(
                typeof mensajeBackend === 'string' && mensajeBackend
                    ? mensajeBackend
                    : t('alerts.downloadInformacionAdicional.error'),
                { variant: 'error' }
            );
        } finally {
            setDescargandoInformacionAdicional(false);
        }
    };

    return { descargandoInformacionAdicional, descargarInformacionAdicional };
};
